import React from 'react'
import { H3, InputLabel, Subheading } from '@fs/zion-ui'

export default ({ label, description, toggleId }) => (
  <H3 size="H6" aria-hidden>
    <InputLabel as="label" aria-hidden htmlFor={toggleId}>
      {label}
    </InputLabel>
    <Subheading aria-hidden>{description}</Subheading>
  </H3>
)
